<template>
  <div class="textarea-reskinned">
    <v-textarea
      :id="id"
      ref="textarea"
      v-model="text"
      :aria-label="label"
      :color="$colors.penChecksTeal"
      :data-id="dataId"
      :disabled="disabled"
      :errorMessages="errors"
      :hide-details="hideDetails"
      :hint="hint"
      :label="showLabel ? label : ''"
      :maxlength="maxLength"
      :no-resize="noResize"
      :persistent-hint="persistentHint"
      :placeholder="placeholder"
      :rows="rows"
      :rules="required ? textRules : []"
      :validate-on-blur="true"
      outlined
      v-on="$listeners"
      @blur="$emit('blur')"
      @change="$emit('change', text)"
      @focus="errors = null"
    ></v-textarea>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      required: false,
    },
    // Used as the accessible name. Rendered as a floating Vuetify label only
    // when showLabel is set — this variant is normally paired with a heading
    // supplied by the parent, which is why showLabel defaults to false.
    label: {
      type: String,
      required: true,
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
    },
    id: {
      type: String,
    },
    dataId: {
      type: String,
      required: false,
      validator(value) {
        return value.length == 32;
      },
    },
    required: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    errorMessages: {
      type: Array,
    },
    hint: {
      type: String,
    },
    persistentHint: {
      type: Boolean,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    // Declared as a real prop so it reaches the inner <textarea>. Vuetify
    // forwards its own $attrs to that element, but an undeclared attribute on
    // this wrapper would stop at the wrapper div and never get there.
    maxLength: {
      type: Number,
    },
    // 4 rows x 20px line-height + 16px vertical padding = the 96px field box.
    rows: {
      type: Number,
      default: 4,
    },
    noResize: {
      type: Boolean,
      default: true,
    },
  },

  data: function () {
    return {
      text: this.value,
      textRules: [
        (v) =>
          !!v ||
          "Please enter " +
            (this.label.toUpperCase() == this.label
              ? this.label
              : this.label.toLowerCase()),
      ],
      errors: null,
    };
  },

  watch: {
    text(newValue) {
      this.$emit("input", newValue);
    },
    value(newValue) {
      if (this.text != newValue) {
        this.text = newValue;
      }
    },
    errorMessages(errors) {
      this.errors = errors;
    },
  },

  mounted: function () {
    this.$emit("mounted");
  },
};
</script>

<style lang="scss">
/* Unscoped: these reach into Vuetify's input internals, which scoped styles
   cannot target. Namespaced by .textarea-reskinned so only this variant is
   affected -- PcTextarea keeps Vuetify's default underline treatment. */
.textarea-reskinned {
  .v-textarea.v-text-field--outlined {
    border-radius: 4px;

    .v-input__slot {
      min-height: 78px;
      /* No padding: the textarea is the scrolling element, so it must span the
         full box or its scrollbar sits inset from the border. */
      padding: 0 !important;
      border-radius: 4px;
      background: #fafafa;
    }

    .v-text-field__slot {
      padding: 0;
    }

    fieldset {
      border-color: rgba(0, 0, 0, 0.12);
    }

    textarea {
      box-sizing: border-box;
      padding: 8px 12px;
      margin: 0 !important;
      align-self: stretch;
      color: rgba(0, 0, 0, 0.87);
      font-family: Roboto, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 142.857% */

      &::placeholder {
        color: rgba(0, 0, 0, 0.44);
      }
    }
  }
}
</style>
